import type { FC, ReactNode } from 'react'

import { Translation } from '@/components/i18n/Translation'

import './warning.scss'

const Warning: FC<{ textId?: string; className?: string; children?: ReactNode }> = ({
  textId,
  className = '',
  children,
}) => (
  <div className={`feedback ui-warning ${className}`}>
    {textId && <Translation id={textId} />}

    {children}
  </div>
)

export default Warning
